import React, { useState, useEffect, useCallback } from "react";

import { Table, Space, Button, Popconfirm, Row } from "antd";

import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  EyeOutlined,
} from "@ant-design/icons";

import {
  CampoBuscaInstantanea,
  destacarBusca,
  useBuscaInstantanea,
} from "../../../../components/CampoBuscaInstantanea";
import { SecaoCard } from "../../../../components/SecaoCard";

import { ModalAdd } from "./components/ModalAdd";
import { openNotification } from "../../../../components/Notification";
import { religiaoService } from "../../../../services/resources/religiaoService";

export const Religiao = () => {
  const [religiao, setReligiao] = useState([]);
  const { busca, onChangeBusca, filtrados, paginacaoBusca } =
    useBuscaInstantanea(religiao, ["descricao"]);

  const [openModal, setOpenModal] = useState(false);

  const [codigo, setCodigo] = useState(null);
  const [codigoDelete, setCodigoDelete] = useState(null);
  const [mode, setMode] = useState("");

  const [disabled, setDisabled] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  useEffect(() => {
    getReligiao();
    // eslint-disable-next-line
  }, []);

  async function getReligiao() {
    try {
      const { data } = await religiaoService.load();
      transformList(data);
    } catch (error) {
      openNotification(
        "error",
        <strong>Ocorreu um erro ao buscar a lista de religiões!</strong>,
        error?.response?.data?.detail
      );
    }
  }

  async function handleDelete(codigo) {
    setConfirmLoading(true);
    setDisabled(true);
    try {
      await religiaoService.delete(codigo);
      openNotification("success", <strong>Religião excluída!</strong>);
      getReligiao();
    } catch (reason) {
      openNotification(
        "error",
        <strong>Não foi possível excluir a religião!</strong>,
        reason?.response?.data?.detail
      );
    } finally {
      setCodigoDelete(null);
      setConfirmLoading(false);
      setDisabled(false);
    }
  }

  const handleOpenModal = useCallback((religiao) => {
    setOpenModal(true);
    setCodigo(religiao?.codigo);
  }, []);

  const handleCloseModal = useCallback(() => {
    setOpenModal(false);
  }, []);

  const transformList = useCallback((list) => {
    list.sort(function (a, b) {
      return a.descricao > b.descricao ? 1 : b.descricao > a.descricao ? -1 : 0;
    });
    setReligiao(list);
  }, []);

  const renderTable = () => {
    const columns = [
      {
        title: <strong>Descrição</strong>,
        dataIndex: "descricao",
        key: "descricao",
        render: (descricao) => destacarBusca(descricao, busca),
      },
      {
        title: <strong>ações</strong>,
        key: "action",
        width: 64,
        render: (religiao) => (
          <Space size="small">
            <Button
              type="primary"
              className="action-button"
              ghost
              title={`Visualizar religião ${religiao?.descricao}`}
              onClick={() => {
                handleOpenModal(religiao);
                setMode("onView");
              }}
            >
              <EyeOutlined style={{ fontSize: "1.2rem" }} />
            </Button>
            <Button
              type="primary"
              className="action-button"
              title={`Editar religião ${religiao?.descricao}`}
              onClick={() => {
                handleOpenModal(religiao);
                setMode("onEdit");
              }}
            >
              <EditOutlined style={{ fontSize: "1.2rem" }} />
            </Button>
            <div>
              <Popconfirm
                title={
                  <span>
                    excluir religião <strong>{religiao?.descricao}</strong>?"
                  </span>
                }
                visible={religiao?.codigo === codigoDelete}
                placement="bottomRight"
                okText="confirmar exclusão"
                cancelText="cancelar"
                icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                onConfirm={() => handleDelete(religiao?.codigo)}
                onCancel={() => setCodigoDelete(null)}
                okButtonProps={{ loading: confirmLoading }}
                disabled={disabled}
                cancelButtonProps={{ disabled: disabled }}
              >
                <Button
                  type="danger"
                  className="action-button"
                  title={`Excluir religião ${religiao?.descricao}`}
                  onClick={() => {
                    setCodigoDelete(religiao?.codigo);
                  }}
                >
                  <DeleteOutlined style={{ fontSize: "1.2rem" }} />
                </Button>
              </Popconfirm>
            </div>
          </Space>
        ),
      },
    ];
    function showTotal(total) {
      return (
        <>
          Total de <strong>{total}</strong> religiões
        </>
      );
    }
    return (
      <Table
        dataSource={filtrados}
        columns={columns}
        size="small"
        rowKey={({ codigo }) => codigo}
        pagination={{
          ...paginacaoBusca,
          showTotal: showTotal,
        }}
      />
    );
  };

  return (
    <>
      <div className="container-section">
        <Row id="header">
          <h2>LISTA DE RELIGIÕES</h2>

          <Button
            type="primary"
            onClick={() => {
              handleOpenModal(null);
              setMode("onCreate");
            }}
          >
            nova religião
          </Button>
        </Row>
        <SecaoCard>
        <CampoBuscaInstantanea
          value={busca}
          onChange={onChangeBusca}
          placeholder="Busque pela religião"
        />
        {renderTable()}
        </SecaoCard>
      </div>

      {openModal && (
        <ModalAdd
          onClose={handleCloseModal}
          codigo={codigo}
          mode={mode}
          reload={getReligiao}
        />
      )}
    </>
  );
};
